import { FC, useState } from 'react';
import { useHistory } from 'react-router';
import { format } from 'date-fns';

import BackButton from 'components/BackButton';
import { StepProps } from 'components/Stepper/types';
import DeactivationDatePicker from 'features/PaymentCards/components/DeactivationDatePicker';
import * as Layout from 'layouts/StepperLayout';

import { CtaButton, SkipStepButton } from '../../../components/Buttons';
import { useVirtualCardOrderFlowContext } from '../../hooks/useVirtualCardOrderFlowContext';
import locales from './locales';

const VirtualCardOrderChooseDeactivationDate: FC<StepProps> = ({ goNext }) => {
  const { goBack: goBackHistory } = useHistory();
  const { setSharedState, sharedState } = useVirtualCardOrderFlowContext();
  const { deactivateAt } = sharedState;

  const [chosenDate, setChosenDate] = useState<Date | null | undefined>(
    undefined,
  );

  const onConfirm = () => {
    const formattedChosenDate = chosenDate
      ? format(chosenDate, 'yyyy-MM-dd')
      : null;
    setSharedState({ ...sharedState, deactivateAt: formattedChosenDate });

    goNext({ key: 'order-recap' });
  };

  return (
    <Layout.Root>
      <Layout.Body>
        <Layout.HeaderButtonsContainer>
          <BackButton onClick={() => goBackHistory()} />
        </Layout.HeaderButtonsContainer>

        <Layout.BodyScrollableSection>
          <DeactivationDatePicker
            chosenDate={chosenDate}
            deactivateAt={deactivateAt}
            setChosenDate={setChosenDate}
          />
        </Layout.BodyScrollableSection>

        <Layout.FooterContainer>
          <Layout.FooterButtonsContainer>
            <SkipStepButton
              onClick={() => goBackHistory()}
              variant="inline-primary"
            >
              {locales.cancel}
            </SkipStepButton>
            <CtaButton isDisabled={!chosenDate} onClick={onConfirm}>
              {locales.confirm}
            </CtaButton>
          </Layout.FooterButtonsContainer>
        </Layout.FooterContainer>
      </Layout.Body>
    </Layout.Root>
  );
};

export default VirtualCardOrderChooseDeactivationDate;
